import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";
import { useQuery } from "react-query";

export const CARENOTES_QUERY_KEY = "CARENOTES_QUERY_KEY";

export const useCareNotesQuery = (patientUserId) => {
  return useQuery({
    queryKey: [CARENOTES_QUERY_KEY, patientUserId],
    retry: false,
    queryFn: getList.bind(this, patientUserId),
    staleTime: Infinity,
    placeholderData: [],
    enabled: !!patientUserId,
  });
};

export const useCareNoteByPredicateQuery = (patientUserId, predicate) => {
  return useQuery({
    queryKey: [CARENOTES_QUERY_KEY, patientUserId],
    retry: false,
    queryFn: getList.bind(this, patientUserId),
    staleTime: Infinity,
    placeholderData: [],
    select: (careNote) => careNote?.filter(predicate) || [],
    enabled: !!patientUserId,
  });
};

const getList = async (patientUserId) => {
  const session = await fetchAuthSession();
  const { body } = await get({
    apiName: "hrcarenotesapi",
    path: "/" + patientUserId,
    options: {
      headers: {
        Authorization: session.tokens.idToken.toString(),
      },
    },
  }).response;
  return await body.json();
};
